<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Dómsdagur podcast',
    titleTemplate: '%s',
    htmlAttrs: {lang: 'is', amp: undefined},
    meta: [
      {'property': 'og:title', 'content': 'Dómsdagur podcast', 'template': '%s', 'vmid': 'og:title'},
      {
        'property': 'og:description',
        'content': 'Dómsdagur podcastið er best',
        'template': '%s',
        'vmid': 'og:description'
      },
      {'property': 'og:site_name', 'content': 'Dómsdagur er kominn', 'template': '%s', 'vmid': 'og:site_name'},
      {'property': 'og:type', 'content': 'website', 'template': '%s', 'vmid': 'og:type'},
      {'property': 'og:url', 'content': 'https://www.domsdagur.com', 'template': '%s', 'vmid': 'og:url'},
      {
        'property': 'og:image',
        'content': 'http://localhost:8080/static/header.png',
        'template': '%s',
        'vmid': 'og:image'
      }
    ]
  }
}
</script>

<style>
body {
  background-color: #000000;
  color: #FFFFFF;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*margin-top: 60px;*/
}

a,
a:visited,
a:active {
  color: #fff;
  text-decoration: none;
}

a:hover {
  color: #a79551;
}
</style>



// WEBPACK FOOTER //
// src/App.vue